import { render, staticRenderFns } from "./listImport.vue?vue&type=template&id=195522df&scoped=true&"
import script from "./listImport.vue?vue&type=script&lang=js&"
export * from "./listImport.vue?vue&type=script&lang=js&"
import style0 from "./listImport.vue?vue&type=style&index=0&id=195522df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195522df",
  null
  
)

export default component.exports